import { type GetTagsQueryParams, getTags } from '@gonfalon/openapi/operations/getTags';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { createInfiniteQueryOptions } from '../internal/createInfiniteQueryOptions';
import { createQueryOptions } from '../internal/createQueryOptions';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export const getTagsQuery = createQueryOptions(getTags);

export const getInfiniteTagsQuery = createInfiniteQueryOptions(getTags);

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const tags = createQueryKeys('tags', {
  list: ({ params }: { params?: GetTagsQueryParams }) => ({
    // Working around some limitations of query-key-factory here.
    //
    // [params] | null is not a valid type for queryKey, so we add a
    // placeholder string ('list') to satisfy the types.
    queryKey: params ? ['collection', params] : ['collection'],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getTags({ query: params }, { signal })),
  }),
});

export const tagsList = tags.list;
